<h1 mat-dialog-title>Delete?</h1>
<div mat-dialog-content>Are you sure you want to delete?</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button (click)="onClickOK()">Delete</button>
</div>